import React from 'react';

import Pic1 from '../../InstallImages/Inverters/Sol-Ark';

const link = <a href="https://www.youtube.com/watch?v=9SZ0bwgNgcA&feature=emb_logo" rel="noopener noreferrer" target="_blank">Sol-Ark 8K: Solar+ Batteries 101 Video</a>;

const link2 = <a href="https://www.dropbox.com/s/rjkamrl7qxag9r4/Sol-Ark-8K-brochure-6-page-9-12-19-edition.pdf?dl=0" rel="noopener noreferrer" target="_blank">Sol-Ark 8K Data Sheet</a>;

const link3 = <a href="https://www.dropbox.com/s/5h3iym9qzeib39n/12K-brochure-4pg-combined-CR-for-Affiliates.pdf?dl=0" rel="noopener noreferrer" target="_blank">Sol-Ark 12K Data Sheet</a>;

const Inverter = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">

            <p className="specsText">Sol-Ark’s all-in-one design cuts install time in half. With two built-in MPPT charge controllers, a user friendly wiring area, and free remote monitoring with simple setup included, you get 9kW continuous / 20kW peak fast and easy. SolArk also guide you with 7 days a week engineering support.
            </p>
            <ul> <h1>Key Features</h1>
                <li className="specsText">Boosts PV energy 10-20% without increasing PV array size and reduces storage inverter costs up to 30%</li>
                <li className="specsText">Improve battery efficiency by 10-15% – Use our Smart Load to enhance both lithium and AGM battery performance!</li>
                <li className="specsText">Simultaneous DC and AC coupling – up to a combined 13kW of PV on 8K. With 9.6kW AC and up to 16.5kW DC on the 12K. Call us for specific AC and DC coupling projects for using the 12K.</li>
                <li className="specsText">No glitch switch!  The Sol-Ark acts as a massive uninterruptible power supply with a lightning fast transfer time during outages. Avoid blinking clocks and data loss from computer glitches.</li>
                <li className="specsText">Approved for: UL1741SA Rule 21, HECO & Canada</li>
                <li className="specsText">Sol-Ark 8K pumps out power just like the grid, allowing you to power 120V and 240V appliances simultaneously</li>
                <li className="specsText">Sol-Ark is expandable from 5 to 36 (11 kW) solar panels and 0-32 batteries.</li>
                <li className="specsText">5-Year Standard Warranty (10-Year extended warranty available)</li>
                <li className="specsText">{link}</li>
                <li className="specsText">{link2}</li>
                <li className="specsText">{link3}</li>
            </ul>
        </div>
    </div>
);


export default Inverter;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Inverters/solark.js